module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component.css
// module id = ./src/app/kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component.css
// module chunks = main